import React from 'react';
import background from '../../assets/urchin.jpg';
import ReusableInfoCard from '../../components/ReusableInfoCard/ReusableInfoCard';


class InfoUrchin extends React.Component {
  render () { 
   return(
  
  <ReusableInfoCard             
    
        tag="OCEANS"
        subtag="OVERPOPULATED"
        description="Sea Urchins"
        paragraph="Urchins on the seafloor, including purple sea urchins, are important prey for sea otters and sea stars. Sea urchin grazing is slowly but steadily decimating kelp forests on the U.S. Pacific Coast."
        background={background}
     />
  
  );
 }
}   

export default InfoUrchin;